import {useIntl} from 'react-intl';

import {IProduct} from 'src/utils/contentful';
import {getImageSourceFromAsset} from 'src/utils/contentful/content-models/util';

import {GridItem} from '../LinkGridLayout';
import {ProductVariantPrice} from '../ProductVariantPrice';
import {ProductLinkGridSection} from '../layout/ProductLinkGridSection';

export interface ProductsIndexPageTemplate {
  products: IProduct[];
}

export const ProductsIndexPageTemplate: React.FC<
  React.PropsWithChildren<ProductsIndexPageTemplate>
> = (props) => {
  const {products} = props;
  const intl = useIntl();

  const productLinks: GridItem[] = products.map((product) => {
    const {
      fields: {name, variants, slug},
    } = product;
    const firstVariant = variants[0];

    const backgroundImage = firstVariant.fields.images
      ? firstVariant.fields.images[0]
      : firstVariant.fields.previewImage;

    return {
      key: product.sys.id,
      title: name,
      subTitle: (
        <ProductVariantPrice variant={firstVariant} intervalFormat={'short'} />
      ),
      backgroundImageSrc: getImageSourceFromAsset(backgroundImage),
      linkTo: `/products/${slug}`,
    };
  });

  const listTitle = intl.formatMessage({
    id: 'ProductsIndexPageTemplate.title',
    defaultMessage: 'Products',
  });

  return <ProductLinkGridSection title={listTitle} items={productLinks} />;
};
